import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const ng78: IProductData = {
  id: "wesaudio-ng78",
  name: "WesAudio _NG78",
  description: "Fully analog stereo FET compressor with digital recall",
  images: ["/img/wesaudio_ng78_front.png", "/img/wesaudio_ng78_left.png", "/img/wesaudio_ng78_back.png"],
  details: [{
    label: "Description",
    markdown: `
FET compressors have long shaped the character and dynamics of recordings in professional studios. 
The ng78 continues this tradition with a two-channel, fully analog design featuring digital recall. 
Each channel offers an extended attack time of up to 20 ms, enabling precise transient control while preserving the signature speed and punch of FET compression. 
The newly added 2:1 ratio delivers subtle, musical compression. 

Introducing the ng78 – a blend of classic FET sound and modern versatility, providing full control across two channels.
`
  }, {
    label: "Key Features",
    markdown: `
### ng78 fully analog, digital control FET compressor.
- 100% analog stereo FET compressor with +24dBu of headroom.
- Five Ratio Settings: 2:1, 4:1, 8:1, 12:1, 20:1.
- Extended Attack Range: slower attack settings for more natural transient control.
- Total Recall & DAW Integration: seamless plug-in control for instant preset recall.
- Parallel Compression: dedicated MIX knob.
- Carnhill Transformer Output Stage for added analog weight and character.
- Flexible Detector Linking: dual mono or true stereo operation.
- Saturation Mode: converts the unit into a saturation box or clipper.
- Metering: gain reduction and input/output meters.
- THD: Low, Mid, High settings for tailored analog character.
- Fully Digital-Controlled Analog Circuit with A/B switching.
`
  }, {
    label: "Main Feature Summary",
    markdown: `
- 100% Analog Stereo FET Compressor (1176-style) with +24dBu of headroom.
- Five Ratio Settings: 2:1, 4:1, 8:1, 12:1, 20:1 – including All-Button Mode and a gentle 2:1 ratio option.
- Total Recall & Plug-in Control – seamless integration with most major DAWs.
- Parallel Compression via dedicated MIX knob.
- Transformer Balanced Output through Carnhill Transformers – delivers rich analog character, depth, and musical warmth.
- Flexible Detector Linking – choose between dual mono stereo compression or true stereo operation.
- Saturation Mode – a dedicated control simultaneously adjusts input and output (compression circuit disabled), turning the unit into a saturation box or clipper.
- Dynamic Link Technology – adaptive circuit that compensates for component tolerances in the sidechain signal, ensuring perfect stereo balance during compression for every parameter combination.
- Advanced sidechain EQ with two independent sections: a high-pass filter at 60 Hz, 90 Hz, or 150 Hz to preserve low-end while compressing, and a high shelf at 2 kHz, 5 kHz, or 10 kHz to emphasize mid/high content for precise detection.
- 2 Vintage-Style Gain Reduction Meters for classic visual feedback.
- Classic FET Compressor Controls: Input, Output, Attack, Release.
- Selectable THD (Total Harmonic Distortion) with Low, Mid, and High modes – tailored harmonic enhancement from the FET circuit.
- Fully Digitally Controlled Analog Circuit – isolated control path ensures pure analog signal integrity.
- Hardware A/B Switching – instantly compare two independent settings.
- Analog Automation in DAW for modern hybrid workflows.
- USB & Ethernet Connectivity for flexible plugin integration.
- Form Factor: 2U rackmount.
`
  }, {
    label: "Specification",
    markdown: `
- Attack Time	20us – 20ms
- Release Time	50ms – 1100ms
- Compression Ratio	2:1, 4:1, 8:1, 12:1, 20:1 (all possible combinations)
- SC High Pass Filter	60,90,150Hz
- SC High Shelf Filter	2kHz, 5kHz, 10kHz
- Output Impedance	50 ohm
- Frequency Response	20Hz-20kHz (+/- 1dB)
- Signal to Noise Ratio SNR	SNR >83dB
- Max Signal Level	+24dBu
- THD+N MIN	0.2%
- Noise Floor	-95dBu
- Power Consumption	14W
- Unit Dimensions	88x483x235mm
- Box Dimensions	580x420x320mm
- Unit Weight	7 kgs
- Box Weight	8 kgs
- Balanced Output and Input	
- Case Rack	2U
- Warranty	2 years
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://wesaudio.com/product/ng78/" target="_blank">https://wesaudio.com/product/ng78/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.NEXT_GEN, HASHTAGS.MASTERING, HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.TWO_U, HASHTAGS.RACK],
    manufacturer: BRAND.WESAUDIO,
  },
  videos: [
    "https://www.youtube.com/embed/YF7pfM4B81o?si=gYS67XJpM_A_x0Ni",
    "https://www.youtube.com/embed/fnCPceGhqYA?si=oGX2WkHo06qvlRwV"
  ]
}